import Home from "./Home";
import Login from "./Login";
import NameGenerator from "./NameGenerator";
import Static from "./Static";
import RichMedia from "./RichMedia";
import HTML5 from "./HTML5";
import Video from "./Video";
import Audio from "./Audio";
import SiteServed from "./SiteServed";
import About from "./About";
import Help from "./Help";
import Preloader from "./Preloader";
import Display from "./Display";
import ChangeLog from "./ChangeLog";
import Default from "./Default";
import Smart from "./Smart";

const indexRoutes = [
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/help",
    name: "Help",
    component: Help
  },
  {
    path: "/staticimage",
    name: "StaticImage",
    component: Static
  },
  {
    path: "/video",
    name: "Video",
    component: Video
  },
  {
    path: "/audio",
    name: "Audio",
    component: Audio
  },
  {
    path: "/name",
    name: "NameGenerator",
    component: NameGenerator
  },
  {
    path: "/richmedia",
    name: "Rich Media/Studio",
    component: RichMedia
  },
  {
    path: "/html5",
    name: "HTML5",
    component: HTML5
  },
  {
    path: "/preloader",
    name: "Preloader",
    component: Preloader
  },
  {
    path: "/siteserved",
    name: "Site Served",
    component: SiteServed
  },
  {
    path: "/default/:defaultDimension",
    name: "Default Uploder",
    component: Default
  },
  {
    path: "/display",
    name: "Display Uploader",
    component: Display
  },
  {
    path: "/smart",
    name: "Smart Upload",
    component: Smart
  },
  {
    path: "/changelog",
    name: "Change Log",
    component: ChangeLog
  },
  {
    path: "/",
    name: "Home",
    component: Home
  }
];

export default indexRoutes;
